import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiSlider from '@material-ui/core/Slider';
import { combineClasses, styled, useThemeProps, } from '../../../foundation';
import { SliderStyle } from './styles';
import { RcSliderClasses } from './utils';
var _RcSlider = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcSlider' });
    var classesProp = props.classes, color = props.color, children = props.children, rest = __rest(props, ["classes", "color", "children"]);
    var classes = useMemo(function () { return combineClasses(RcSliderClasses, classesProp); }, [classesProp]);
    return (React.createElement(MuiSlider, __assign({}, rest, { ref: ref, classes: classes }), children));
});
var RcSlider = styled(_RcSlider)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), SliderStyle);
RcSlider.defaultProps = {
    valueLabelDisplay: 'auto',
    color: 'interactive.f01',
};
RcSlider.displayName = 'RcSlider';
export { RcSlider };
var templateObject_1;
